import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

import { TRANSLATIONS as T } from '../../../constants/translations-constants'
import { FSMBtnNext } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'

const useCTAStyles = makeStyles()((theme: Theme) => ({
  actionButtons: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(1),
      '& > button:not(:last-child)': {
        marginBottom: theme.spacing(3),
      },
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
      paddingTop: theme.spacing(5),
      '& > button:not(:last-child)': {
        marginRight: theme.spacing(2),
      },
    },
  },

  button: {
    ...theme.brand.assets.layout?.ctaOverride,
    [theme.breakpoints.up('md')]: {
      width: '325px',
    },
  },
}))

interface CTAProps {
  isVerify: boolean
  // DFE-4063: gate "Gå til kjøp" until a claims value is selected + submit on click.
  goToPurchaseDisabled: boolean
  onGoToPurchase(isVerify: boolean): void
}

const CTA: FC<CTAProps> = ({ isVerify, goToPurchaseDisabled, onGoToPurchase }) => {
  const { t } = useTranslate(T.OFFER_REVIEW)
  const { classes } = useCTAStyles()

  return (
    <section className={classes.actionButtons}>
      <FSMBtnNext
        handleClick={() => onGoToPurchase(isVerify)}
        disabled={goToPurchaseDisabled}
        buttonText={t(`goToPurchase`)}
        customClassName={classes.button}
        testId='goto-purchase-button'
      />
    </section>
  )
}

export default CTA
